export const getDaysAgo = (today: Date, pastDateISO: string): number => {
  const pastDate = new Date(pastDateISO);

  // Clear the time part to ensure only full days are counted
  const msPerDay = 1000 * 60 * 60 * 24;
  const utcToday = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  const utcPast = Date.UTC(
    pastDate.getFullYear(),
    pastDate.getMonth(),
    pastDate.getDate()
  );

  const diffInMs = utcToday - utcPast;
  return Math.floor(diffInMs / msPerDay);
};
